var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPolygonArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Polygon 1",
    d: "M1.04977 3.50554C0.642591 2.01254 2.01254 0.642589 3.50553 1.04977L24.9271 6.89201C26.7832 7.39821 26.9796 10.1086 25.2677 10.9863C22.3553 12.4795 18.928 14.5102 16.7191 16.7191C14.5103 18.9279 12.4796 22.3553 10.9863 25.2677C10.1086 26.9796 7.39822 26.7832 6.89202 24.9271L1.04977 3.50554Z",
    fill: "url(#paint0_linear_28_98)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_28_98",
    x1: -1.26225,
    y1: 20.9955,
    x2: 20.9955,
    y2: -1.26225,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7D61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDB59"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolygonArrow);
export default __webpack_public_path__ + "static/media/Polygon-arrow.a13bfb5d263158ca37ba2a89ca367414.svg";
export { ForwardRef as ReactComponent };